import configObservable from '../../api/config/observable';
import { IConfig } from '../../types/interfaces/config';
import { store } from '../../store/store';
import { setUrls } from '@shared/store/slices/app.slice';
import AnalyticsInstance from '@shared/utils/analytics';

export default function initAppConfig() {
  configObservable.subscribe({
    next: (val: IConfig[]) => {
      store.dispatch(setUrls(val));
    },
    error: () => {
      console.error('Error recovering config');
    },
    complete: () => {
      return null;
    },
  });
}
